const URL = {
  CREATE_COURSE_COLLECTION: 'CourseCollection/Create',
  DELETE_COURSE_COLLECTION: 'CourseCollection/Delete',
  COLLECTION_TRANSLATE: 'CourseCollection/{id}/Translate',
  COLLECTION_TRANSLATION_COST_ESTIMATE:
    'CourseCollection/{id}/TranslationCostEstimate',
  COLLECTION_CLONE: 'CourseCollection/{id}/Clone',
  COLLECTION_TRANSLATIONS: 'CourseCollection/{id}/Translations',
  PATCH_COLLECTION: 'CourseCollection/Patch',
  LIST_COURSE_COLLECTION: 'CourseCollection/GetCourseCollectionByFilter',
  UPDATE_COURSE_COLLECTION: 'CourseCollection/Edit',
  EDIT_ASSIGNMENT_COURSE_COLLECTION_INDEX: 'Course/EditCourseCollectionIndex',
  PATCH_COLLECTION_COURSE: 'Course/Patch',
  GET_COLLECTION_TEAM_LIST: 'CourseCollection',
  GET_COLLECTION_SETTINGS: '/settings',
  SEND_COLLECTION_TEST_EMAIL: '/settings/test-email',
  GET_COLLECTION_ANALYTICS: 'courseCollection/{collectionId}/report/analytics',
  DOWNLOAD_COLLECTION_EXCEL:
    'courseCollection/{collectionId}/report/analytics/export-to-excel',
  GET_COLLECTION_LANDING_PAGE: 'collection/{id}/landing-page',
  PATCH_COLLECTION_LANDING_PAGE: 'collection/{id}/landing-page',
  PATCH_COLLECTION_PAYMENT_MESSAGES:
    'CourseCollection/{collectionId}/payment-setting/messages',
}

export default URL
